export default {
	"Beans.MyGrowingBeans": "My growing beans",
	"Beans.MarketingMallComponentClick": "Marketing Mall_Component click",
	"Beans.MarketingMarketplace": "Marketing Marketplace",
	"Beans.ViewDetails": "View details",
	"Beans.MyRedemptionHistory": "My redemption history",
	"Beans.RedemptionHistory": "Redemption history"
}